module.exports = __webpack_public_path__ + "img/screen.31e50d2e.png";